import type { ReactNode } from 'react';

interface LandingHeroProps {
  children: ReactNode;
}

export const LandingHero = ({ children }: LandingHeroProps) => {
  return (
    <section
      id="hero"
      className="landing-container relative mx-auto h-(--landing-hero-height) w-full max-w-400"
    >
      <div
        className="
          relative flex size-full max-h-5/6 grow flex-col gap-6 py-24
          md:py-40
          lg:justify-center lg:py-24
        "
      >
        {children}
      </div>
    </section>
  );
};
